import React, { useEffect, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

/* import element from component folder */
import Table from "../../modelTable";

/* import function from store folder */
import { setModel } from '../../../store/components/modelSlice';
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import fetch function */
import { FetchGroupLevelSource, CreateEventGroup } from "../../../services/events";

const CreateGroupEvent = () => {
    const { RangePicker } = DatePicker;
    const dispatch = useDispatch();
    const { data } = useSelector(state => state.model);
    const [error, setError] = useState({});
    const [source, setSource] = useState({});
    const [tableLists, setTableLists] = useState([]);
    const defaultPicker = (!data?.egId && data?.startDate && data?.endDate) ? [dayjs(data.startDate),  dayjs(data.endDate)] : null;
    
    const cancelHandler = () => dispatch(resetModel());
    const changHandler = ({target: { name, value }}) => {
        const _source = Object.assign({}, source);
        
        delete error[name];
        _source[name] = value;
        
        setError(error);
        setSource(_source);
    };

    const intervalPickerHandler = dates => {
        let _source = Object.assign({}, source);
        
        if (!dates) {
            delete _source.startDate;
            delete _source.endDate;
        }
        else {
            const startDate = new Date(`${dates[0].$y}-${dates[0].$M + 1}-${dates[0].$D}`);
            const endDate = new Date(`${dates[1].$y}-${dates[1].$M + 1}-${dates[1].$D}`);

            startDate.setHours(0, 0, 0, 0);
            endDate.setHours(0, 0, 0, 0);
            
            _source.startDate = startDate.getTime();
            _source.endDate = endDate.getTime();
        }
        
        setSource(_source);
    };

    const removeHandle = removeId => {
        const _tableLists = [...tableLists];
        const index = _tableLists.findIndex(({ eglId }) => eglId === removeId);
        
        if (index > -1)
            _tableLists.splice(index, 1);

        setTableLists(_tableLists);
    };

    const validate = () => {
        const checkLists = ['eventName', 'startDate', 'endDate'];
        const _errors = {};

        checkLists.map( list => (
            (!source[list]) && (_errors[list] = true)
        ));
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    const modelHandler = modelType => {
        const _source = Object.assign({}, source);

        _source.tableLists = [...tableLists];

        dispatch(setModel({type: modelType, data: _source}));
    };

    const createFormData = () => {
        const formData = new FormData();

        formData.append('eventName', source.eventName);
        formData.append('startDate', source.startDate);
        formData.append('endDate', source.endDate);
        
        if (tableLists.length)
            tableLists.map((value, index) => {
                const _value = Object.assign({}, value);
                const keys = Object.keys(_value);

                delete _value.eglId;
                keys.map(key => {
                    if (key === 'photo')
                        formData.append(`levels[${index}].oldMonsterPhoto`, value[key]);
                    else
                        formData.append(`levels[${index}].${key}`, value[key]);
                });
            });

        return formData;
    };

    const submitHandler = event => { 
        event.preventDefault();
        const isValidate = validate();
        
        if (isValidate) {
            const resource = createFormData();

            CreateEventGroup(resource).then(response => {
                if (!Object.keys(response).length) {
                    cancelHandler();
                    dispatch(setAction());
                }
            });
        }
    };

    useEffect(() => {
        if (!data?.egId) {
            const _source = Object.assign({}, source);
            
            if (data?.tableLists?.length) {
                setTableLists(data.tableLists);
            }

            if (data?.eventName)
                _source.eventName = data.eventName;

            if (data?.startDate && data?.endDate) {
                _source.endDate = data.endDate;
                _source.startDate = data.startDate;            
            }

            setSource(_source);
        }
        else {
            const resource = { skip: 0, top: 9999 };

            FetchGroupLevelSource(({ id: data.egId, source: resource}))
            .then(value => { setTableLists(value.data); });
        }
    }, []);
    
    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>Create Data</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" onSubmit={ submitHandler }>
                    <div className="form-item">
                        <div className='label'>Event Name</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='eventName' placeholder='Please enter the event name.' defaultValue={ source?.eventName } is-required={`${error.eventName}`} onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Event Date</div>
                        <span className='semicolon'>：</span>
                        <RangePicker className='form-picker' defaultValue={ defaultPicker } status={ (error['startDate'] || error['endDate']) && 'error' } onChange={ intervalPickerHandler } />
                        <Button type="button" data-shadow onClick={ () => modelHandler('group-level') }>Add Level</Button>
                    </div>
                    <div className="form-item">
                        <Table header={ [
                            { key: 'level', value: 'Level' },
                            { key: 'value', value: 'Value' },
                            { key: 'minValue', value: 'Per Check Hour Min Value' },
                            { key: 'checkHour', value: 'Check Hour' },
                            { key: 'increaseValue', value: 'Unreached Increase Value' },
                            { key: 'description', value: 'Description' },
                            { key: 'photo', value: 'Image' },
                            { key: 'delete', value: 'Delete' }
                            ] } body={ tableLists } totalCount={ tableLists.length } idKey="eglId" action={ { delete: removeHandle } } />
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="button" data-shadow onClick={ submitHandler }>Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default CreateGroupEvent;